<template>
  <div class="full_width">
    <v-btn class="refresh-button" @click="refreshOrders()">
      <v-icon color="#6E6E6E">mdi-sync</v-icon>
    </v-btn>
    <div class="table-style">
      <div class="table-header">
        <div class="pill-radio-buttons-div">
          <PillRadioButtons
            :selectedValue="
              Array.isArray(statusSelection) ? 'all' : statusSelection
            "
            :itemsList="statusValuesList"
            @update-selected-value="statusSelection = $event"
          />
        </div>
        <div class="pill-radio-buttons-div">
          <PillRadioButtons
            :selectedValue="regionalTeamSelection"
            :itemsList="regionalTeamList"
            @update-selected-value="regionalTeamSelection = $event"
          />
        </div>
        <div class="pill-radio-buttons-div">
          <v-text-field
            rounded
            outlined
            dense
            full-width
            v-model="searchValue"
            prepend-inner-icon="mdi-magnify"
            @input="elasticSearchOnBackend"
            label="Suche"
            single-line
            hide-details
          />
        </div>
      </div>
      <v-data-table
        disable-sort
        :headers="headersAktive"
        :items="activeOrdersDisplayed"
        item-key="orderId"
        :loading="loading"
        :loading-text="$t('overview_table.loading_text')"
        :no-data-text="
          this.isDataLoaded
            ? $t('overview_table.no_filter_data')
            : $t('overview_table.error_data')
        "
        :footer-props="{
          'items-per-page-options': [10],
        }"
        :server-items-length="filteredActiveOrdersCount"
        calculate-widths
        :options.sync="options"
        :page="currentPage"
      >
        <template v-slot:[`item.date`]="{ item }">
          <span>{{ item.date | formatDate('DD.MM.YYYY HH:mm') }}</span>
        </template>
        <template v-slot:[`item.status`]="props">
          <v-btn rounded dark :color="props.item.status.color">{{
            props.item.status.label
          }}</v-btn>
        </template>
        <template v-slot:[`item.edit`]="props">
          <v-btn icon @click="showDetails(props.item.orderId)">
            <v-icon>mdi-pencil-box-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import orderService from '../../services/OrderService';
import { getOrdersTableConfig } from './ordersTableConfig';
import { tableOrderMapper } from './transform_raw_data_to_orders_table_format';
import { PillRadioButtons } from '@newnetzportal/netzportal-webapp-storybook-components';

export default {
  name: 'ClerkOrdersOverviewTable',
  components: {
    PillRadioButtons,
  },
  created() {
    this.loading = true;
    this.getOrdersWithFilter();
  },
  data() {
    return {
      filterJourney: this.$route.query.journey
        ? this.$route.query.journey
        : 'all',
      statusSelection: this.$route.query.order_status
        ? this.$route.query.order_status
        : 'all',
      regionalTeamSelection: this.$route.query.rt
        ? this.$route.query.rt
        : 'all',
      activeOrdersDisplayed: [],
      currentPage: this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1,
      loading: false,
      options: {},
      searchValue: this.$route.query.search ? this.$route.query.search : '',
      filteredActiveOrdersCount: 0,
      statusValuesList: getOrdersTableConfig('statusValuesList'),
      headersAktive: getOrdersTableConfig('headersAktive'),
      regionalTeamList: getOrdersTableConfig('regionalTeams'),
      isDataLoaded: false,
    };
  },
  computed: {
    journeyFilter() {
      return this.$store.state.orders.journeyFilter;
    },
  },
  watch: {
    journeyFilter(newValue) {
      this.currentPage = 1;
      if (newValue !== 'all') {
        this.filterJourney = newValue;
      } else {
        this.filterJourney = '';
      }
      this.updateURLParams({ name: 'journey', value: this.filterJourney });
      this.getOrdersWithFilter();
    },
    $route(to) {
      if (to.fullPath === '/netzanschluesse') {
        this.refreshOrders();
      }
    },
    regionalTeamSelection(newValue) {
      this.currentPage = 1;
      if (newValue !== 'all') {
        this.regionalTeamSelection = newValue;
      }
      this.$store.commit('setOrderRegionalTeamFilter', newValue);
      this.updateURLParams({ name: 'rt', value: newValue });
      this.getOrdersWithFilter();
    },
    statusSelection(newValue) {
      this.currentPage = 1;
      if (newValue !== 'all') {
        this.statusSelection = newValue;
      }
      this.$store.commit('setOrderstatusFilter', newValue);
      this.updateURLParams({ name: 'order_status', value: newValue });
      this.getOrdersWithFilter();
    },
    searchValue(newValue) {
      this.updateURLParams({ name: 'search', value: newValue });
    },
    options: {
      handler(event) {
        this.updateURLParams({ name: 'page', value: event.page });
        this.currentPage = event.page;
        this.getOrdersWithFilter();
      },
      deep: true,
    },
  },
  methods: {
    updateURLParams(param) {
      const params = this.$route.query;
      if (!param.value) {
        delete params[param.name]; // remove param if empty
      } else {
        params[param.name] = param.value;
      }

      history.replaceState(
        {},
        null,
        `${this.$route.path}?${new URLSearchParams(params)}`
      );
    },
    refreshOrders() {
      const params = this.$route.query;
      params.page = 1;
      params.order_status = '';
      params.rt = '';
      if (params.journey) delete params.journey;
      if (params.search) delete params.search;

      this.$store.commit('setJourneyFilter', 'all');
      this.statusSelection = '';
      this.regionalTeamSelection = '';
      this.filterJourney = '';
      this.searchValue = '';
      this.currentPage = 1;

      history.replaceState(
        {},
        null,
        `${this.$route.path}?${new URLSearchParams(params)}`
      );

      this.getOrdersWithFilter();
    },
    elasticSearchOnBackend(value) {
      if (value.length === 0 || value.length > 2) {
        this.currentPage = 1;
        this.getOrdersWithFilter();
      }
    },
    getOrdersWithFilter(search_word) {
      const params = {
        limit: 10,
        order_status:
          this.statusSelection === 'all' ? '' : this.statusSelection,
        journey:
          !this.filterJourney || this.filterJourney === 'all'
            ? ''
            : this.filterJourney,
        regional_team:
          this.regionalTeamSelection === 'all'
            ? ''
            : this.regionalTeamSelection,
        from_index: (this.currentPage - 1) * 10,
        search_word: search_word ? search_word : this.searchValue,
      };
      this.loading = true;
      orderService
        .getOrdersWithFilter(params)
        .then((res) => {
          if (res.getOrdersWithFilter) {
            this.filteredActiveOrdersCount =
              res.getOrdersWithFilter.count_orders;
            const ordersWithStatusConfig = this.addStatusConfigForEachOrder(
              res.getOrdersWithFilter.items
            );
            this.activeOrdersDisplayed =
              ordersWithStatusConfig.map(tableOrderMapper);
            this.loading = false;
            this.isDataLoaded = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isDataLoaded = false;
          this.activeOrdersDisplayed = [];
          console.log(err);
        });
    },
    showDetails(orderId) {
      this.$store.commit('deleteSelectedOrder');
      this.$router.push({ name: 'Details', params: { id: orderId } });
    },
    addStatusConfigForEachOrder(ordersArray) {
      ordersArray.forEach((item) => {
        item.status = this.statusValuesList.find(
          (status) => status.value === item.status
        );
      });
      return ordersArray;
    },
  },
};
</script>
